import { makeStyles } from '@material-ui/core/styles';
import { condensedStyles } from 'core/components/theme/condensed-layout';

import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  header: {
    marginBottom: 40,
    flexWrap: 'nowrap'
  },
  container: {
    position: 'relative',
    padding: 0
  },
  fixedButtonContainer: {
    position: 'fixed',
    top: theme.sizes.headerHeight + 40,
    left: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  iconButtonRoot: {
    position: 'absolute',
    color: theme.colors.action_icon,
    left: -48,
    padding: 0,
    ...condensedStyles(theme, { position: 'static' })
  },
  iconButtonLabel: {
    height: 48,
    width: 48
  },
  icon: {
    height: 48,
    width: 48
  },
  iconImg: {
    transform: 'rotate(180deg)'
  },
  navigatorIconImg: {
    height: 40,
    width: 40
  },
  rightLabel: {
    fontSize: '14px',
    display: 'inline',
    marginRight: 8
  },
  rightValue: {
    fontSize: '14px',
    display: 'inline'
  },
  rightContainer: {
    composes: '$container',
    marginTop: 10
  },
  subtitle: {
    paddingRight: 10
  },
  rightSideInfo: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginRight: 8
  },
  sourceLabel: {
    fontSize: '14px',
    display: 'inline',
    marginRight: 0
  },
  sourceTooltipIcon: {
    width: 16,
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(2)
  },
  agencyTag: {
    backgroundColor: theme.colors.badge_background,
    padding: theme.spacing(2, 4),
    height: 32,
    width: 136,
    gap: theme.spacing(2),
    ...reskinStyles(theme, theme.labelStyles.outlined)
  },
  statusPillBase: {
    borderRadius: theme.spacing(8),
    fontSize: 12,
    fontWeight: 600,
    height: 24,
    padding: theme.spacing(1, 2),
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    marginLeft: theme.spacing(2),
    // New look: the Label's shape and type; each status keeps its fill.
    ...reskinStyles(theme, {
      borderRadius: theme.labelStyles.outlined.borderRadius,
      padding: theme.labelStyles.outlined.padding,
      fontSize: theme.labelStyles.outlined.fontSize,
      fontWeight: theme.labelStyles.outlined.fontWeight
    })
  },
  statusPillActive: { backgroundColor: theme.colorPalette.green_success_light, color: theme.colorPalette.green_100 },
  statusPillFuture: { backgroundColor: theme.colorPalette.green_75, color: theme.colorPalette.white },
  statusPillInCancellation: { backgroundColor: theme.colorPalette.orange_50, color: theme.colorPalette.white },
  statusPillCancelled: { backgroundColor: theme.colorPalette.beige_75, color: theme.colorPalette.white },
  statusPillInactive: {
    backgroundColor: theme.colors.badge_background,
    color: theme.colorPalette.green_100,
    // New look: no status color, so the plain outlined Label.
    ...reskinStyles(theme, theme.labelStyles.outlined)
  },
  // Condensed layout: the policy panel header, one title row and a facts row.
  condensedHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  titleRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(3)
  },
  titleGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2, 3),
    minWidth: 0
  },
  condensedTitle: {
    margin: 0
  },
  condensedStatusPill: {
    marginLeft: 0
  },
  factsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(3.5, 5)
  },
  facts: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
    gap: theme.spacing(3.5, 5),
    margin: 0
  },
  factLabel: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 18,
    marginBottom: theme.spacing(0.75),
    fontSize: 12,
    color: theme.colorPalette.beige_90
  },
  factValue: {
    margin: 0,
    fontSize: 14,
    fontWeight: 600,
    color: theme.colors.info__label_primary,
    overflowWrap: 'anywhere'
  }
});

export default makeStyles(styles);
